import { useSelector } from '@legendapp/state/react';
import { ui$, setSnippetFilter } from '@/stores/ui$';
import { getSnippetFilterCounts } from '@/stores/snippets$';
import { cn } from '@/lib/utils';
import { ThumbsUp, Heart } from 'lucide-react';

export default function SnippetFilterBar({ noteId }) {
  const snippetFilter = useSelector(() => ui$.snippetFilter.get());
  const counts = getSnippetFilterCounts(noteId);

  // Don't show bar if no votes or favorites
  if (counts.upvoted === 0 && counts.favorited === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 px-6 py-2 border-b border-border/50 bg-muted/20">
      <span className="text-xs text-muted-foreground font-medium">Filter:</span>

      {counts.upvoted > 0 && (
        <button
          onClick={() => setSnippetFilter('upvoted')}
          className={cn(
            "flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium transition-all",
            snippetFilter === 'upvoted'
              ? "bg-green-100 dark:bg-green-950/40 text-green-700 dark:text-green-400 ring-1 ring-green-200 dark:ring-green-800"
              : "bg-muted hover:bg-muted/80 text-muted-foreground hover:text-foreground"
          )}
        >
          <ThumbsUp size={12} fill={snippetFilter === 'upvoted' ? 'currentColor' : 'none'} />
          <span>Upvoted</span>
          <span className={cn(
            "px-1.5 py-0.5 rounded-full text-[10px] font-mono",
            snippetFilter === 'upvoted'
              ? "bg-green-200 dark:bg-green-900/50 text-green-800 dark:text-green-300"
              : "bg-background text-muted-foreground"
          )}>
            {counts.upvoted}
          </span>
        </button>
      )}

      {counts.favorited > 0 && (
        <button
          onClick={() => setSnippetFilter('favorited')}
          className={cn(
            "flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium transition-all",
            snippetFilter === 'favorited'
              ? "bg-pink-100 dark:bg-pink-950/40 text-pink-700 dark:text-pink-400 ring-1 ring-pink-200 dark:ring-pink-800"
              : "bg-muted hover:bg-muted/80 text-muted-foreground hover:text-foreground"
          )}
        >
          <Heart size={12} fill={snippetFilter === 'favorited' ? 'currentColor' : 'none'} />
          <span>Favorited</span>
          <span className={cn(
            "px-1.5 py-0.5 rounded-full text-[10px] font-mono",
            snippetFilter === 'favorited'
              ? "bg-pink-200 dark:bg-pink-900/50 text-pink-800 dark:text-pink-300"
              : "bg-background text-muted-foreground"
          )}>
            {counts.favorited}
          </span>
        </button>
      )}

      {snippetFilter && (
        <button
          onClick={() => setSnippetFilter(null)}
          className="ml-auto text-xs text-muted-foreground hover:text-foreground transition-colors underline"
        >
          Clear filter
        </button>
      )}
    </div>
  );
}
